export default "__VITE_ASSET__B8rReA4c__"